"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.maximumNumberOfUploadSessionInWorkflowActionValidator = exports.safeSelectedItemListAllowedValuesValidator = exports.selectedItemListAllowedValuesValidator = exports.safeSelectedItemAllowedValuesValidator = exports.selectedItemAllowedValuesValidator = exports.safeAllowedValuesValidator = exports.allowedValuesValidator = void 0;
const allowedValuesValidator = (allowedValues) => ({
    customValidator: (value) => allowedValues.includes(value),
    errorMessage: `Value must be one of the following: ${allowedValues.join(", ")}`,
});
exports.allowedValuesValidator = allowedValuesValidator;
const safeAllowedValuesValidator = (allowedValues) => ({
    customValidator: (value) => (value ? allowedValues.includes(value) : true),
    errorMessage: `Value must be one of the following: ${allowedValues.join(", ")}`,
});
exports.safeAllowedValuesValidator = safeAllowedValuesValidator;
const selectedItemAllowedValuesValidator = (allowedValues) => ({
    customValidator: (value) => allowedValues.includes(value.id),
    errorMessage: `Value must be one of the following: ${allowedValues.join(", ")}`,
});
exports.selectedItemAllowedValuesValidator = selectedItemAllowedValuesValidator;
const safeSelectedItemAllowedValuesValidator = (allowedValues) => ({
    customValidator: (value) => (value ? allowedValues.includes(value.id) : true),
    errorMessage: `Value must be one of the following: ${allowedValues.join(", ")}`,
});
exports.safeSelectedItemAllowedValuesValidator = safeSelectedItemAllowedValuesValidator;
const selectedItemListAllowedValuesValidator = (allowedValues) => ({
    customValidator: (value) => value.every((item) => allowedValues.includes(item.id)),
    errorMessage: `Value must be an array of the following: ${allowedValues.join(", ")}`,
});
exports.selectedItemListAllowedValuesValidator = selectedItemListAllowedValuesValidator;
const safeSelectedItemListAllowedValuesValidator = (allowedValues) => ({
    customValidator: (value) => { var _a; return (_a = value === null || value === void 0 ? void 0 : value.every((item) => allowedValues.includes(item.id))) !== null && _a !== void 0 ? _a : true; },
    errorMessage: `Value must be an array of the following: ${allowedValues.join(", ")}`,
});
exports.safeSelectedItemListAllowedValuesValidator = safeSelectedItemListAllowedValuesValidator;
const maximumNumberOfUploadSessionInWorkflowActionValidator = (maximumNumberOfFiles) => ({
    customValidator: (value) => ((value === null || value === void 0 ? void 0 : value.uploadIds) ? value.uploadIds.length <= maximumNumberOfFiles : true),
    errorMessage: `Maximum number of files per session is ${maximumNumberOfFiles}`,
});
exports.maximumNumberOfUploadSessionInWorkflowActionValidator = maximumNumberOfUploadSessionInWorkflowActionValidator;
//# sourceMappingURL=utilityValidators.js.map